import React from 'react'
import injectStyles from 'react-jss'
import ImageIcon from '@material-ui/icons/Image'
import VideocamIcon from '@material-ui/icons/Videocam'
import DescriptionIcon from '@material-ui/icons/Description'
import classnames from 'classnames'

import { CHAT_MESSAGE_TYPES } from '../../../../shared/constants'
import styles from '../styles'

const chatInputByTypes = {
  [CHAT_MESSAGE_TYPES.IMAGE]: {
    label: 'Image',
    icon: <ImageIcon />,
    formats: '.jpg, .jpeg, .png',
  },
  [CHAT_MESSAGE_TYPES.VIDEO]: {
    label: 'Video',
    icon: <VideocamIcon />,
    formats: '.mp4, .webm',
  },
  [CHAT_MESSAGE_TYPES.FILE]: {
    label: 'File',
    icon: <DescriptionIcon />,
    formats: 'text/plain, application/pdf, .doc, .docx',
  },
}

const ChatFileUploadTypeButton = ({ type, onChange, classes }) => {
  const { label, icon, formats } = chatInputByTypes[type]
  return (
    <div
      className={classnames(classes.buttonWrapper, 'ChatFileUploadTypeButton')}
    >
      <div className={classes.icon}>{icon}</div>
      <span className={classes.label} cypress_id={'ChatFileUploadFileTypeItem'}>
        {label}
      </span>
      <label
        for={`chatUpload-${type}`}
        className={classes.hiddenInputClickArea}
      />
      <input
        className={classes.hiddenInput}
        type="file"
        id={`chatUpload-${type}`}
        name={`chatUpload-${label}`}
        accept={formats}
        onChange={onChange}
      />
    </div>
  )
}

export default injectStyles(styles)(ChatFileUploadTypeButton)
